(() => {
	/** @type {HTMLAnchorElement[]} */
	const linkIcons = Array.from(document.querySelectorAll("section[id] a.js-link"));

	for (const linkIcon of linkIcons) {
		const id = linkIcon.closest("section[id]").id;
		const url = `${window.location.origin}${window.location.pathname}#${id}`;
		linkIcon.href = url;
	}
})();

// Swiper slideshow library setup (max lines slideshow).
(() => {
	new Swiper('.max-lines-slideshow', {
		direction: 'horizontal',

		navigation: {
			nextEl: '.max-lines-slideshow .swiper-button-next',
			prevEl: '.max-lines-slideshow .swiper-button-prev',
		},

		pagination: {
			el: ".max-lines-slideshow .swiper-pagination",
			clickable: true,
		},
	});
})();

// Swiper slideshow library setup (display height slideshows).
(() => {
	const els = [
		".dh-automatic-slideshow",
		".dh-longest-verse-slideshow",
		".dh-standard-slideshow",
	];

	for (const el of els) {
		new Swiper(el, {
			direction: "horizontal",

			navigation: {
				nextEl: `${el} .swiper-button-next`,
				prevEl: `${el} .swiper-button-prev`,
			},

			pagination: {
				el: `${el} .swiper-pagination`,
				clickable: true,
			},
		});
	}

})();